import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initSentry, Sentry } from './lib/sentry';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './lib/firebase';
import { markBoot } from './debug/BootSentinel';
import { ErrorBoundary } from './debug/ErrorBoundary';
import './debug/globalErrorTrap';

markBoot('START');

// Initialize Sentry
initSentry();

// after imports of env & sentry
markBoot('PRE_RENDER', { env: process.env.NODE_ENV || 'production' });

// Set user context after Firebase auth
onAuthStateChanged(auth, user => {
  Sentry.setUser(user ? { id: user.uid, email: user.email ?? undefined } : null);
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
markBoot('POST_RENDER_ENQUEUED');
